import { Skeleton } from './Skeleton'

// Grid skeleton for cards view
export const GridLoadingSkeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
    {[1, 2, 3, 4, 5, 6].map((idx) => (
      <div key={idx} className="card p-4 flex flex-col" style={{ animationDelay: `${idx * 50}ms` }}>
        {/* Header */}
        <div className="flex justify-between gap-2 mb-3">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-5 w-16 rounded-full" />
        </div>
        {/* Salary */}
        <Skeleton className="h-6 w-28 mb-3" />
        {/* URL */}
        <Skeleton className="h-4 w-24 mb-3" />
        {/* Tech stack */}
        <div className="flex gap-1.5 mb-3">
          <Skeleton className="h-5 w-12 rounded" />
          <Skeleton className="h-5 w-14 rounded" />
          <Skeleton className="h-5 w-10 rounded" />
        </div>
        {/* Spacer */}
        <div className="flex-1 min-h-[20px]" />
        {/* Footer */}
        <div className="pt-3 border-t border-app-line/50 space-y-2">
          <div className="flex justify-between">
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-3 w-8" />
          </div>
          <Skeleton className="h-1.5 w-full rounded-full" />
          <div className="flex justify-between">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-10" />
          </div>
        </div>
      </div>
    ))}
  </div>
)

// Table skeleton for table view
export const TableLoadingSkeleton = () => (
  <div className="space-y-2">
    {[1, 2, 3, 4, 5].map((idx) => (
      <div key={idx} className="flex items-center gap-4 p-3 bg-app-surface/30 rounded-2xl shadow-app-card">
        <Skeleton className="h-4 w-4 rounded" />
        <Skeleton className="h-4 w-40" />
        <Skeleton className="h-5 w-20 rounded-full" />
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-16" />
      </div>
    ))}
  </div>
)
